export default function CircleTextWidget({
  content,
  value = {},
  onChange,
  mode = "edit",
  feedback
}) {
  const showFeedback = Boolean(feedback?.parts);

  function select(id, option) {
    if (mode !== "edit" || showFeedback) return;
    onChange({ ...value, [id]: option });
  }

  /* ───────── INLINE TEXT RENDERING ───────── */
  function renderInline(item, key) {
    if (item == null) return null;

    if (typeof item === "string" || typeof item === "number") {
      return <span key={key}>{item}</span>;
    }

    if (typeof item === "object") {
      if (item.italic) return <em key={key}>{item.italic}</em>;
      if (item.bold) return <strong key={key}>{item.bold}</strong>;
      if (item.underline) {
        return (
          <span key={key} style={{ textDecoration: "underline" }}>
            {item.underline}
          </span>
        );
      }
    }

    return null;
  }

  function renderChoice(item) {
    const { id, options, separator = " or ", lastSeparator } = item;
    const selected = value?.[id];

    const part = feedback?.parts?.[id];
    const expected = part?.expected;

    return (
      <span>
        {"("}
        {options.map((opt, i) => {
          const isSelected = selected === opt;

          // const isCorrect =
          //   showFeedback && opt === expected;

          // const isWrong =
          //   showFeedback && isSelected && opt !== expected;
          const isCorrect =
            showFeedback &&
            isSelected &&
            part?.correct === true;

          const isWrong =
            showFeedback &&
            isSelected &&
            part?.correct === false;

          const sep =
            i < options.length - 2
              ? separator
              : i === options.length - 2
              ? lastSeparator ?? separator
              : "";

          return (
            <span key={opt}>
              <span
                className={[
                  "circle-choice",
                  !showFeedback && isSelected && "selected",
                  isCorrect && "correct",
                  isWrong && "wrong"
                ]
                  .filter(Boolean)
                  .join(" ")}
                onClick={() => select(id, opt)}
                style={{
                  fontWeight: 600,
                  cursor:
                    mode === "edit" && !showFeedback
                      ? "pointer"
                      : "default"
                }}
              >
                {opt}
              </span>
              {sep}
            </span>
          );
        })}
        {")"}
      </span>
    );
  }

  return (
    <>
      {content.map((item, i) => {
        if (item?.type === "choice") {
          return <span key={item.id}>{renderChoice(item)}</span>;
        }
        return renderInline(item, i);
      })}
    </>
  );
}
